/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'

const $nsid = 'com.atproto.sync.defs'

export { $nsid }

type HostStatus =
  'active' | 'idle' | 'offline' | 'throttled' | 'banned' | l.UnknownString

export type { HostStatus }

const hostStatus = /*#__PURE__*/ l.string<{
  knownValues: ['active', 'idle', 'offline', 'throttled', 'banned']
}>()

export { hostStatus }
